import { selector } from "recoil";
import { bankFilterState, banksState } from "./atoms";

export const filteredBankState = selector({
    key: 'filteredBankState',
    get: ({ get }) => {
        const filter = get(bankFilterState)
        const banks = get(banksState)
        return banks.filter(bank => bank.name.includes(filter))
    }
})